import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _WifiOffIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.81081 5.3966C6.82218 5.40743 6.8333 5.41856 6.84418 5.42997L10.7878 9.37359C10.8507 9.42296 10.9077 9.47987 10.9575 9.54326L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L15.6763 17.0905C15.4156 17.1427 15.1347 17.0913 14.9008 16.9252C13.1668 15.6932 10.8432 15.6932 9.10915 16.9252C8.65893 17.245 8.03464 17.1394 7.71478 16.6891C7.39491 16.2389 7.50059 15.6146 7.95082 15.2948C9.33815 14.3091 10.9951 13.8868 12.6134 14.0277L9.83187 11.2461C8.29273 11.593 6.85566 12.3019 5.64146 13.3171C5.21776 13.6714 4.5871 13.6151 4.23285 13.1914C3.87859 12.7677 3.93489 12.137 4.35859 11.7828C5.50171 10.827 6.80929 10.0972 8.21145 9.62566L5.88764 7.30186C4.50326 7.91882 3.21984 8.74381 2.08234 9.74927C1.66854 10.115 1.03657 10.0761 0.670802 9.6623C0.305033 9.2485 0.343971 8.61653 0.757772 8.25076C1.85745 7.27873 3.07738 6.45542 4.38598 5.80019L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
        fill={iconColor}
      />
      <Path
        d="M13 20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20Z"
        fill={iconColor}
      />
      <Path
        d="M17.1585 10.1614C16.6622 9.91913 16.0635 10.1251 15.8213 10.6214C15.579 11.1178 15.785 11.7165 16.2814 11.9587C17.0256 12.3219 17.7215 12.7767 18.353 13.3125C18.7741 13.6699 19.4051 13.6182 19.7624 13.197C20.1198 12.7759 20.0681 12.1449 19.647 11.7876C18.8885 11.1439 18.0525 10.5976 17.1585 10.1614Z"
        fill={iconColor}
      />
      <Path
        d="M10.7903 6.0468C14.8485 5.71979 18.8654 7.05648 21.9185 9.74992C22.3326 10.1153 22.9645 10.0757 23.3299 9.66158C23.6953 9.24743 23.6557 8.6155 23.2416 8.25013C19.7814 5.19756 15.229 3.68266 10.6297 4.05326C10.0792 4.09762 9.66889 4.57984 9.71324 5.13034C9.7576 5.68085 10.2398 6.09115 10.7903 6.0468Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const WifiOffIcon = assignWithoutSideEffects(_WifiOffIcon, {
  componentId: 'WifiOffIcon',
});

export default WifiOffIcon;
